module.exports = __webpack_public_path__ + "img/nhm.a1fd3b2f.png";